async function request(url, data = {}, init = {}, method = "GET") {
  const defaultConfig = {
    method
  };
  const defaultHeaders = {
    "Accept": "application/json",
    "Content-Type": "application/json"
  };
  let response;
  if (Object.prototype.hasOwnProperty.call(init, "headers")) {
    init.headers = Object.assign(defaultHeaders, init.headers);
  } else {
    init.headers = defaultHeaders;
  }
  const options = {
    ...defaultConfig,
    ...init
  };
  if (method === "GET") {
    let getUrl = "";
    if (!Object.keys(data).length) {
      getUrl = url;
    } else {
      getUrl = url + "?" + new URLSearchParams(data).toString();
    }
    response = await fetch(getUrl, options);
  } else {
    options.body = JSON.stringify(data);
    response = await fetch(url, options);
  }
  const responseHeader = [...response.headers];
  if (responseHeader[0][1] === "text/html; charset=UTF-8") {
    const parser = new DOMParser();
    try {
      const json2 = await response.clone().json();
      return Promise.resolve(json2);
    } catch (err) {
      try {
        const xmlStr = await response.text();
        const xmlDoc = parser.parseFromString(xmlStr, "text/xml");
        return Promise.resolve(xmlDoc);
      } catch (err2) {
        return Promise.reject(err2);
      }
    }
  }
  const json = await response.json();
  if (response.status === 200) {
    return Promise.resolve(json);
  }
  return Promise.reject(response);
}
async function get(url, data = {}, init = {}) {
  return request(url, data, init, "GET");
}
async function post(url, data = {}, init = {}) {
  return request(url, data, init, "POST");
}
export { get, post };
